import { memo, useCallback } from 'react';
import { IconTextStyleBold } from '../../../icons';
import { useTiptap } from '../Tiptap';
import { type Editor, useEditorState } from '@tiptap/react';
import TiptapToolbarButton from './tiptap-toolbar-button';

const TiptapBold = memo(() => {
  const { editor } = useTiptap();

  const editorState = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      isBold: editor.isActive('bold'),
    }),
  });

  const onClick = useCallback(() => editor.chain().focus().toggleBold().run(), [editor]);

  return (
    <TiptapToolbarButton
      aria-label="gras"
      tooltip="Gras"
      icon={IconTextStyleBold}
      isActive={editorState.isBold}
      onClick={onClick}
    />
  );
});

TiptapBold.displayName = 'Tiptap.Toolbar.Bold';

export default TiptapBold;
